import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import SchedulingCalendar from "./SchedulingCalendar";

const Booking = () => (
  <section id="book" data-testid="booking-section" className="px-6 md:px-12 py-24 md:py-36 border-t border-line">
    <div className="mx-auto max-w-[100rem] grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
      <div>
        <Reveal>
          <p className="overline-label">09 — Limited Availability</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-4xl md:text-6xl font-light tracking-tight leading-[1.05]">
            Ready to accelerate your growth? <em className="text-taupe">Only a few client spots open each quarter.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-base md:text-lg font-light text-ash leading-relaxed max-w-md">
            Availability is intentionally limited — a small number of clients
            each quarter ensures full focus and real results. Pick a time below
            and let's discuss how fractional CMO leadership can unlock your next
            stage of growth.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <a
            data-testid="booking-email-link"
            href="mailto:aspenmakkarcmo@gmail.com"
            className="group mt-10 inline-flex items-center gap-3 font-serif italic text-xl md:text-3xl break-all border-b border-ink/20 hover:border-taupe pb-2 transition-colors duration-300"
          >
            aspenmakkarcmo@gmail.com
            <ArrowUpRight size={20} className="text-taupe transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <SchedulingCalendar />
        <p className="mt-4 text-center text-[10px] uppercase tracking-[0.2em] text-ash">
          Instant confirmation · Calendar invite sent automatically
        </p>
      </Reveal>
    </div>
  </section>
);

export default Booking;
